import React from "react";
import { WiDaySunny } from "react-icons/wi";
import { v4 as uuidv4 } from "uuid";
import { AddPreview } from "./AddPreview/AddPreview";
import { ControlPanel } from "./ControlPanel";
import { PlayerDevice } from "./Player";
import { PreviewPlayer } from "./PlayerPreview";
export const WeatherWidget = {
    id: "6f139f9e-24a0-4947-9263-7b2a446e1f30",
    name: "Météo",
    icon: React.createElement(WiDaySunny, null),
    type: "Météo",
    inHeadbar: true,
    description: "Ajout de la météo (Actuelle, toutes les 3h, journalière)",
    keywords: [
        "température",
        "temps",
        "météo",
        "weather",
        "celcius",
        "fahrenheit",
        "meteo",
        "temperature",
        "mét",
    ],
    config: null,
    createdAt: "2022-07-18T08:03:18.585Z",
    updatedAt: "2022-07-18T08:03:18.585Z",
    isActive: true,
    isDeleted: false,
    load: null,
    scope: ["font"],
    controlPanel: ControlPanel,
    playerPreview: PreviewPlayer,
    context: null,
    playerDevice: PlayerDevice,
    contextDevice: ({ children }) => React.createElement(React.Fragment, null, children),
    addWidgetPreview: AddPreview,
    height: "auto",
    factory: () => ({
        id: uuidv4(),
        data: {
            type: "current",
            city: {
                label: "Toulouse, FR",
                lat: 43.6044622,
                lon: 1.4442469,
            },
            unit: "celcius",
            font: "Lobster",
            weight: "400",
            fontWeight: 400,
            textColor: "#ffffff",
            backgroundColor: {
                type: "color",
                color: "#333333",
                gradient: {
                    start: "#1C93FF",
                    end: "#5CB9FF",
                },
            },
            theme: "default",
            weather: {
                city: {
                    name: "Toulouse",
                    country: "FR",
                },
                weather: {
                    date: new Date(),
                    description: "Ciel dégagé",
                    icon: "01d",
                    temp: 30,
                    temp_max: 35,
                    temp_min: 10,
                },
            },
        },
    }),
    resize: {
        bottom: false,
        bottomLeft: true,
        bottomRight: true,
        left: false,
        right: false,
        top: false,
        topLeft: true,
        topRight: true,
    },
    scalePlayer: true,
};
